import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c795209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "settings-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-heading" }, /*#__PURE__*/_toDisplayString('Settings'), -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-subheading" }, /*#__PURE__*/_toDisplayString('Units'), -1))
const _hoisted_6 = { class: "settings-content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Close", -1))
const _hoisted_9 = [
  _hoisted_8
]

import GameFormat from '@/view-models/gameFormat';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsModal',
  emits: ['saveSettings', 'close'],
  setup(__props, { emit: __emit }) {

let gameFormats = JSON.parse(localStorage.getItem('gameTypes'));

const emit = __emit
function saveSettings(vote: GameFormat) {
    emit('saveSettings', vote);
}

function close() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameFormats), (vote) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `vote-${vote}`,
              class: "button",
              onClick: () => saveSettings(vote)
            }, [
              _createElementVNode("span", null, _toDisplayString(vote.name), 1)
            ], 8, _hoisted_7))
          }), 128)),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }, _hoisted_9)
        ])
      ])
    ])
  ]))
}
}

})